define('home/views/BasePopoverView',[
    'jquery',
    'backbone',
], function (
    $,
    Backbone
) {
    'use strict';

    /**
     * Abstract base class for popover views.
     *
     * Implements several helpers for displaying and hiding the popover.
     *
     * Subclasses must bind a click event to onBodyClick for the view to hide correctly.
     */
    var BasePopoverView = Backbone.View.extend({
        className: 'popover notch-up notch--mobile-hidden',

        initialize: function (options) {
            this.$target = options.$target;
        },

        move: function () {
            // Append to viewport so that the tooltip doesn't
            // appear over the fixed nav header
            this.$el.detach().appendTo('.viewport');

            this.render();

            this.delegateEvents();

            this.updatePosition(this.$target, '.viewport');
        },

        /*
         * Positions the popover below the target element.
         *
         * Will try to position popover horizontally so it doesn't get cut off
         * on either side.
         */
        updatePosition: function ($target, containerSelector) {
            var targetTop = $target.offset().top;
            var targetLeft = $target.offset().left;
            var targetHeight = $target.height();
            var targetWidth = $target.width();

            var popoverWidth = this.$el.width();

            var $win = $(window);
            var winWidth = $win.width();
            var viewportTop = $(containerSelector).offset().top;

            var alignment = this.constructor.calculateHorizontalAlignment(
                targetLeft, targetWidth, popoverWidth, winWidth);

            // toggle classes so the notch moves accordingly
            this.$el.toggleClass('-right', alignment.position === 'right');
            this.$el.toggleClass('-left', alignment.position === 'left');

            this.$el.css({
                top: targetTop + targetHeight + this.constructor.TOP_MARGIN - viewportTop,
                left: alignment.left,
                bottom: 'inherit',
                'z-index': this.constructor.Z_INDEX,
            });
        },

        show: function () {
            this.move();

            this.$el.addClass('open');
        },

        hide: function () {
            this.$el.removeClass('open');
        },

        /**
         * Event handler for any click events.
         * Will hide the view if the click is not on the target or the card.
         */
        onBodyClick: function (evt) {
            var $evtTarget = $(evt.target);

            // if the target element was clicked on, don't do anything
            if ($evtTarget.closest(this.$target).length)
                return;

            // if the card itself was clicked on, don't do anything
            if ($evtTarget.closest(this.$el).length)
                return;

            this.hide();
        },
    }, {
        // Space above card so notch does not overlap target
        TOP_MARGIN: 20,  /* px */

        Z_INDEX: 550,

        /**
         * Calculates how the popover should be horizontally aligned to the target.
         *
         * Prefers centering when possible, but will fall back on left or right alignment
         * if part of the popover card would be outside the window.
         */
        calculateHorizontalAlignment: function (targetLeft, targetWidth, popoverWidth, winWidth) {
            var centeredLeft = targetLeft - (popoverWidth - targetWidth) / 2;
            var rightAlignedLeft = targetLeft + targetWidth - popoverWidth;
            var leftAlignedLeft = targetLeft;

            // right align when center-aligning cuts off to the right and right-aligning doesn't cut off to the left
            var shouldRightAlign = centeredLeft + popoverWidth > winWidth && rightAlignedLeft > 0;

            // left align when center-aligning cuts off to the left and left-aligning doesn't cut off to the right
            var shouldLeftAlign = centeredLeft < 0 && leftAlignedLeft + popoverWidth < winWidth;

            // center-align when center-aligning doesn't cut off to the right or left
            var shouldCenterAlign = centeredLeft + popoverWidth < winWidth && centeredLeft > 0;

            var left, position;
            if (shouldCenterAlign) {
                position = 'centered';
                left = centeredLeft;
            } else if (shouldRightAlign) {
                position = 'right';
                left = rightAlignedLeft;
            } else if (shouldLeftAlign) {
                position = 'left';
                left = leftAlignedLeft;
            } else {
                // if all else fails, just position at left edge of page
                position = 'leftEdge';
                left = 0;
            }

            return {
                position: position,
                left: left,
            };
        },
    });

    return BasePopoverView;
});

